var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHandshake = function SvgIconHandshake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.107 8.421.394-3.545H8.703c-.454 0-.895.155-1.25.439L6.048 6.439a2 2 0 0 1-1.25.439H3.5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h3.671a2 2 0 0 1 1.414.586l2 2a2 2 0 0 0 2.829 0l3.421-3.421a2 2 0 0 0 0-2.83l-2.156-2.155a1.998 1.998 0 0 1-.574-1.636h.002Z",
    fill: "#FFD3C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.954 6.438 16.55 5.313a2 2 0 0 0-1.25-.439h-.97a2 2 0 0 0-1.414.586L8.088 10.29c-.6.6-.6 1.573 0 2.171a2 2 0 0 0 2.828 0l1.672-1.671a2 2 0 0 1 2.828 0l.587 5.086h4.5a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-1.3c-.453 0-.894-.155-1.25-.439Z",
    fill: "#FFB9A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.837 12.213-1.421-1.422v5.086h.586l.837-.836a2 2 0 0 0 0-2.829h-.002Z",
    fill: "#FFD3C0"
  })));
};
export default SvgIconHandshake;